







































import { Vue, Component, Prop } from "vue-property-decorator";
import api, { fileApi } from "@/getinfo-api";
import CPage from "@/components/form/CustomPage/CPage.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import TextField from "@/components/form/CustomPage/textField.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import {
  Import as IImport,
  UserImportCsvAllOf
} from "@/api-v2/import-export/models";
import { ModelFile as IModelFile } from "@/api-v2/files/models/model-file";
import { BaseFile as IBaseFile } from "@/api-v2/files/models/base-file";
import ImportErrorList from "@/components/imports/ImportErrorList.vue";

@Component({
  components: { ImportErrorList, CustomButton, TextField, CBlock, CPage }
})
export default class ImportUserCsvDetail extends Vue {
  @Prop() importObject!: IImport & { importType: UserImportCsvAllOf };
  isLoading: boolean = false;

  get usersCount() {
    return this.importObject.importType?.users?.length ?? 0;
  }

  async toUsersEditPage() {
    if (this.importObject.importType?.users?.length) {
      this.isLoading = true;
      let users: any = [];
      let subUsers: any[] = [];
      let size = 100; //размер подмассива
      for (
        let i = 0;
        //@ts-ignore
        i < Math.ceil(this.importObject.importType.users.length / size);
        i++
      ) {
        //@ts-ignore
        subUsers[i] = this.importObject.importType.users.slice(
          i * size,
          i * size + size
        );
      }
      await Promise.all(
        subUsers.map(async el => {
          await api.UsersApi.listDocumentInfo(el).then(res => {
            if (res.data && res.data.items) {
              users = [...res.data.items, ...users];
            }
          });
        })
      );

      await localStorage.setItem("importedUsers", JSON.stringify(users));
      this.isLoading = false;
      this.$router.push({ name: "importedUsers" });
    }
  }

  isFile(file: IModelFile | IBaseFile): file is IModelFile {
    return !!(file as IModelFile).url;
  }

  downloadFile(diskId: string, fileId: string) {
    fileApi.FileApiV2.files(diskId, [fileId]).then(res => {
      if (res.data[0]) {
        let file: IBaseFile = res.data[0];
        if (this.isFile(file)) {
          let linkToFile = document.createElement("a");
          if (file.url) {
            linkToFile.href = file.url;
            linkToFile.target = "_blank";
            linkToFile.download = file.url;
            linkToFile.click();
          }
        }
      }
    });
  }
}
